/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTemplateDto } from '../../models/ticket-template-dto';

export interface CenterTicketTypeControllerGetDefaultTypes$Params {
}

export function centerTicketTypeControllerGetDefaultTypes(http: HttpClient, rootUrl: string, params?: CenterTicketTypeControllerGetDefaultTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TicketTemplateDto>>> {
  const rb = new RequestBuilder(rootUrl, centerTicketTypeControllerGetDefaultTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TicketTemplateDto>>;
    })
  );
}

centerTicketTypeControllerGetDefaultTypes.PATH = '/api/ticket-type/center/default';
